export enum ClientType {
    Proposer = "001",
    Life_Assurred = "002",
    Proposer_Assurred = "003",
    Payor = "007",
    Beneficiary = "099",
  }
  